import { render, staticRenderFns } from "./DiscoverNav.vue?vue&type=template&id=943e4e60&"
import script from "./DiscoverNav.vue?vue&type=script&lang=js&"
export * from "./DiscoverNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports